import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject, injectable } from 'inversify'
import { TemporaryBusinessResponse } from '../domain/dtos/temporary-business-response'

@injectable()
export class GetTemporaryBusiness {
  public constructor(@inject(HttpClient) private readonly httpClient: HttpClient) {}

  public async execute(): Promise<TemporaryBusinessResponse> {
    const URI = process.env['NX_BFF_WEB_URL'] ?? process.env['REACT_APP_HUB_API']

    if (!URI) {
      throw new Error('errors.general')
    }

    const response = await this.httpClient.request({
      url: `${URI}/kyc/temporary-business-identity`,
      method: HttpMethod.GET,
    })

    switch (response.statusCode) {
      case HttpStatusCode.OK:
        return response.data
      default:
        throw new Error('errors.general')
    }
  }
}
